import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
    makeStyles
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { closeDeleteItemsDialog } from "./items-delete-slice";
import { db } from "../../../../firebase";
import { useEffect, useState } from "react";
import { deleteItemsService } from "./items-delete-service";
import { useNavigate } from "react-router-dom";
import { showErrorSnackbar } from "../../../shared/snackbar/snackbar-slice";

const useStyles = makeStyles((theme) => ({
    button: {
        background: "#111111",
        color: "#fbbbd3",
        '&:hover': {
            backgroundColor: '#fbbbd3',
            color: '#111111',
        },
    },
    buttonText: {
      color: "#111111",
      '&:hover': {
        backgroundColor: '#fbbbd3',
        color: '#111111',
    },
    },
    title: {
        background:"#111111",
    },
    text: {
        color: "#111111",
    },
}));

const initiaFormData = {
    code: "",
    name: "",
    description: "",
    pieces: 0,
    original_price: 0,
    increase: 0,
    unit_price: 0,
    rent_price: 0,
    rent_percent: 0,
    deposit: 0,
    deposit_percent: 0,
    type: "",
    status: "",
    category: "",
};

const ItemsDelete = () => {
    const classes = useStyles();
    const itemsData = useSelector((state) => state.itemsDeleteSlice.itemsDelete);
    const showDialog = useSelector((state) => state.itemsDeleteSlice.showDialog);
    const isLoading = useSelector((state) => state.itemsDeleteSlice.isLoading);
    const [formData, setFormData ] = useState(initiaFormData);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const itemsId = itemsData.id;

    // get data
    useEffect(() => {
        if (showDialog) {
            setFormData(itemsData);
        }
    }, [showDialog, itemsData]);

    // handle delete
    const handleDeleteSubmit = async (e) => {
        try {
            await deleteItemsService(dispatch, db, "items", itemsId);
            navigate('/admin/items');
        } catch (e) {
            dispatch(showErrorSnackbar("Something went wrong while trying to delete."));
            console.error("ItemsDelete handleDeleteSubmit error: ", e);
        }

        handleDeleteClose();
    };

    // handle close delete
    const handleDeleteClose = () => {
        dispatch(closeDeleteItemsDialog());
    };

    return (
        <Dialog
            open={showDialog}
        >
            <DialogTitle className={classes.title}>
                Delete Item
            </DialogTitle>
            <DialogContent>
                <Typography className={classes.text}>
                    {`Do you want to delete '${formData?.code} - ${formData?.name}'?`}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    className={classes.button}
                    onClick={handleDeleteSubmit}
                    disabled={isLoading}
                >
                    {
                        isLoading ? (
                            "Deleting..."
                        ) : (
                            "Delete"
                        )
                    }
                </Button>
                <Button
                    variant="text"
                    className={classes.buttonText}
                    onClick={handleDeleteClose}
                    disabled={isLoading}
                >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ItemsDelete;